import RootStore from "../rootStore";

const copyPolygonsHandler = (store: RootStore) => {

    const {
        labelerSegmentationUiStore: {
            polygons,
            setCopyPolygons,
            setSavedPolygons
        },
        labelerSegmentationStore: {
            batch,
            numImage        
        }
    } = store;

    setSavedPolygons({
        polygons,
        batchId: batch.id,
        numImage
    });
    setCopyPolygons(true);

}

export default copyPolygonsHandler